import { createInterfaceId } from "@gitlab/needle";
//#region src/git/commands/git_ls_files.ts
const GitLsFiles = createInterfaceId("GitLsFiles");
function isUnsupportedDircacheError(error) {
	return error instanceof Error && "code" in error && error.code === "InternalError" && error.message.includes("Unsupported dircache version: ");
}
//#endregion
//#region src/git/commands/git_config.ts
const GitConfigCommand = createInterfaceId("GitConfigCommand");
//#endregion
export { GitLsFiles as n, isUnsupportedDircacheError as r, GitConfigCommand as t };

//# sourceMappingURL=git_config-CLNchKNV.mjs.map